export const normalizeBusinessSlug = (value: unknown) => {
  if (typeof value !== "string") {
    return ""
  }

  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
}

export const getSponsorBusinessSlug = (data: Record<string, any>) =>
  normalizeBusinessSlug(data.businessSlug || data.publicSlug || data.name)

export const hasDuplicateSponsorSlug = (
  docs: Array<{ id: string }>,
  currentSponsorId: string | null | undefined,
) => docs.some((doc) => doc.id !== currentSponsorId)
